import * as tslib_1 from "tslib";
import { AfterViewInit, EventEmitter, ViewContainerRef } from '@angular/core';
import { environment } from '../../../environment';
import { LayerService } from '../../../services/layer.service';
import { SpatialQueryService } from '../../../services/spatialQuery.service';
import { LogLevel } from '../../../types';
import { BaseComponent } from '../../base.component';
var LayerSpatialQueryComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LayerSpatialQueryComponent, _super);
    function LayerSpatialQueryComponent(_vcr, layerService, spatialQueryService, LoggingService) {
        var _this = _super.call(this, _vcr) || this;
        _this.layerService = layerService;
        _this.spatialQueryService = spatialQueryService;
        _this.LoggingService = LoggingService;
        _this.onboundarysourcechanged = new EventEmitter();
        _this.onapply = new EventEmitter();
        _this.primaryDynamicLayers = [];
        _this.joinedDynamicLayers = [];
        _this.primaryFeatureLayers = [];
        _this.joinedFeatureLayers = [];
        _this.joinedGeometries = [];
        _this.primaryLayerList = [];
        _this.joinedLayerList = [];
        _this.tempJoinedList = [];
        _this.selectedPrimaryLayers = [];
        _this.srMatch = true;
        _this.filteredGeometryString = '';
        _this.hideValues = ['4', '5', '6'];
        _this.showValueInOption = false;
        _this.drawBoundary = false;
        //chosenMulitSelect: SelectOptionData[] = [];
        _this.multiSelect = false;
        _this.graphicsObject = [];
        _this.boundaryType = '';
        _this.processingType = 'Default';
        _this.queryOptions = [{
                value: true,
                text: 'Intersect'
            }, {
                value: false,
                text: 'Difference'
            }];
        _this.layerOptions = [{
                value: true,
                text: 'Create New Layer(s)'
            }, {
                value: false,
                text: 'Update Layer(s)'
            }];
        _this.reset = function () {
            _this.isIntersect = true;
            _this.newLayer = true;
            _this.selectedPrimaryLayers = [];
            _this.selectedJoinedLayers = [];
            _this.graphicsObject = [];
            _this.filteredGeometryString = '';
            _this.srMatch = true;
            _this.disable = false;
            _this.windowRef.hidden = false;
            _this.drawBoundary = false;
            _this.geographicFilter.runSpatialQueryOnSketchComplete = false;
            _this.geographicFilter.spatialQuerySelection = true;
            _this.geographicFilter.containerElement = _this.hostElement;
            _this.processingType = 'Default';
            if (_this.primaryLayers && _this.primaryLayers.length > 0) {
                _this.primaryLayerList = _this.spatialQueryService.GetMapLayerList(_this.primaryLayers, true).reverse();
                _this.joinedLayerList = _this.spatialQueryService.GetMapLayerList(_this.joinedLayers).reverse();
                _this.tempJoinedList = _this.joinedLayerList;
                _this.selectedPrimaryLayers = _this.primaryLayerList;
                _this.setPrimaryLayers();
            }
            else {
                var layers = _this.layerService.mapRef.layers.toArray();
                _this.primaryLayerList = _this.spatialQueryService.GetMapLayerList(layers, true).reverse();
                _this.joinedLayerList = _this.spatialQueryService.GetMapLayerList(layers).reverse();
                _this.tempJoinedList = _this.joinedLayerList;
            }
        };
        return _this;
    }
    Object.defineProperty(LayerSpatialQueryComponent.prototype, "getSpatialQueryService", {
        get: function () {
            return this.spatialQueryService;
        },
        enumerable: true,
        configurable: true
    });
    LayerSpatialQueryComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mapRef, _a, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.isReady();
                        return [4 /*yield*/, this.getClosestAncestor('mc-map')];
                    case 1:
                        mapRef = _c.sent();
                        return [4 /*yield*/, mapRef.ready];
                    case 2:
                        _c.sent();
                        //this.mapView = mapRef.mapView;
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 3:
                        //this.mapView = mapRef.mapView;
                        _a.mapView = _c.sent();
                        this.geographicFilter.containerElement = this.hostElement;
                        this.geographicFilter.onboundarysourcechanged.subscribe(function (source) {
                            if (source) {
                                _this.reset();
                            }
                            _this.onboundarysourcechanged.emit(source);
                        });
                        _b = this;
                        return [4 /*yield*/, this.getClosestAncestor('mc-window')];
                    case 4:
                        _b.windowRef = _c.sent();
                        this.windowRef.addEventListener('openChange', function (open) {
                            if (!open.detail) {
                                _this.close(true);
                            }
                            else if (!_this.geographicFilter.isActivated) {
                                _this.geographicFilter.activate();
                            }
                        });
                        if (!this.geoFilterOnDraweSub) {
                            this.geoFilterOnDraweSub = this.geographicFilter.ondraw.subscribe(function () {
                                _this.boundaryType = '';
                                _this.windowRef.hidden = true;
                            });
                        }
                        if (!this.geoFilterOnDrawCompleteSub) {
                            this.geoFilterOnDrawCompleteSub = this.geographicFilter.ondrawcomplete.subscribe(function (data) {
                                _this.filteredGeometryString = JSON.stringify(data[0]);
                                _this.setupGraphics(_this.getGeometryFromPolygon(data[0]));
                                _this.windowRef.hidden = false;
                            });
                        }
                        if (!this.onfeatureschangedSub) {
                            this.onfeatureschangedSub = this.geographicFilter.onfeatureschanged.subscribe(function (data) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var geometryString;
                                return tslib_1.__generator(this, function (_a) {
                                    geometryString = data.geometryString;
                                    this.boundaryType = data.boundaryType ? data.boundaryType.displayText : '';
                                    if (geometryString !== null) {
                                        this.filteredGeometryString = geometryString;
                                        this.setupGraphics(this.getGeometryFromPolygon(JSON.parse(geometryString)));
                                    }
                                    else {
                                        this.graphicsObject = [];
                                        this.filteredGeometryString = '';
                                    }
                                    return [2 /*return*/];
                                });
                            }); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerSpatialQueryComponent.prototype.getGeometryFromPolygon = function (polygonGeometry) {
        return { rings: polygonGeometry.rings, type: 'polygon', spatialReference: this.layerService.mapView.spatialReference };
    };
    LayerSpatialQueryComponent.prototype.setupGraphics = function (geometry) {
        this.graphicsObject = [{
                geometry: geometry,
                symbol: {
                    type: 'simple-fill',
                    color: [0, 0, 0, 0],
                    style: 'solid',
                    outline: {
                        style: 'solid',
                        color: [0, 0, 0, 1],
                        width: 3
                    }
                }
            }];
        if (this.graphicsObject.length === 0 && geometry === null) {
            this.disable = true;
        }
        else {
            this.disable = false;
        }
    };
    LayerSpatialQueryComponent.prototype.runSpatialQuery = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dynamicResults, featureResults, spatialQueryParams, graphicsProperties, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, 7, 8]);
                        this.disable = true;
                        this.showLoader = true;
                        if (!(this.selectedJoinedLayers && this.selectedJoinedLayers.length > 0 && this.graphicsObject.length === 0)) { //boundary spatial query
                            this.joinedGeometries = [this.filteredGeometryString];
                        }
                        dynamicResults = [];
                        featureResults = [];
                        if (!(this.primaryDynamicLayers && this.primaryDynamicLayers.length && this.primaryDynamicLayers.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.spatialQueryService.spatialQuery(this.isIntersect, this.primaryDynamicLayers, [], this.joinedDynamicLayers, this.joinedFeatureLayers, this.joinedGeometries, this.processingType, this.srMatch)];
                    case 1:
                        dynamicResults = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(this.primaryFeatureLayers && this.primaryFeatureLayers.length && this.primaryFeatureLayers.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.spatialQueryService.spatialQuery(this.isIntersect, [], this.primaryFeatureLayers, this.joinedDynamicLayers, this.joinedFeatureLayers, this.joinedGeometries, this.processingType, this.srMatch, true)];
                    case 3:
                        featureResults = _a.sent();
                        _a.label = 4;
                    case 4:
                        this.results = tslib_1.__spread(dynamicResults, featureResults);
                        spatialQueryParams = {
                            primaryDynamicLayers: [],
                            primaryFeatureLayers: [],
                            joinedDynamicLayers: this.joinedDynamicLayers,
                            joinedFeatureLayers: this.joinedFeatureLayers,
                            joinedGeometries: this.joinedGeometries,
                            isIntersect: this.isIntersect,
                            guid: '',
                            processingType: this.processingType,
                            srMatch: this.srMatch
                        };
                        return [4 /*yield*/, this.spatialQueryService.handleResults(this.results, spatialQueryParams, this.newLayer, this.isIntersect)];
                    case 5:
                        _a.sent();
                        //add border
                        if (this.drawBoundary && this.graphicsObject && this.graphicsObject.length > 0) {
                            graphicsProperties = {
                                graphics: this.graphicsObject,
                                title: this.boundaryType ? this.boundaryType : 'Selected Area'
                            };
                            this.layerService.addGraphicsLayer(graphicsProperties);
                        }
                        return [3 /*break*/, 8];
                    case 6:
                        error_1 = _a.sent();
                        this.LoggingService.Log(error_1, LogLevel.Error);
                        return [3 /*break*/, 8];
                    case 7:
                        this.geographicFilter.boundarySource = 'system';
                        this.disable = false;
                        this.showLoader = false;
                        this.onapply.emit({ isNewLayer: this.newLayer, results: this.results });
                        this.reset();
                        this.close();
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    LayerSpatialQueryComponent.prototype.setPrimaryLayers = function () {
        var _this = this;
        this.primaryDynamicLayers = [];
        this.primaryFeatureLayers = [];
        this.spatialQueryService.filterSelectedLayers(this.selectedPrimaryLayers, this.primaryDynamicLayers, this.primaryFeatureLayers);
        this.joinedLayerList = this.tempJoinedList;
        this.selectedPrimaryLayers.forEach(function (layer) {
            _this.joinedLayerList = _this.joinedLayerList.filter(function (l) { return l.id !== layer.id; });
            _this.selectedJoinedLayers = _this.selectedJoinedLayers.filter(function (l) { return l.id !== layer.id; });
        });
        if (this.selectedPrimaryLayers.length === 0 || this.selectedJoinedLayers.length === 0) {
            this.disable = true;
        }
        else {
            this.disable = false;
        }
    };
    LayerSpatialQueryComponent.prototype.setJoinedLayers = function () {
        this.joinedFeatureLayers = [];
        this.joinedDynamicLayers = [];
        this.joinedGeometries = [];
        this.spatialQueryService.filterSelectedLayers(this.selectedJoinedLayers, this.joinedDynamicLayers, this.joinedFeatureLayers, this.joinedGeometries);
        if (this.selectedPrimaryLayers.length === 0 || this.selectedJoinedLayers.length === 0) {
            this.disable = true;
        }
        else {
            this.disable = false;
        }
    };
    LayerSpatialQueryComponent.prototype.setProcessingType = function (type) {
        this.processingType = type;
    };
    LayerSpatialQueryComponent.prototype.close = function (ignoreWindow) {
        if (ignoreWindow === void 0) { ignoreWindow = false; }
        this.drawBoundary = false;
        this.showValueInOption = false;
        this.graphicsObject = [];
        this.filteredGeometryString = '';
        this.geographicFilter.resetComponent();
        if (!ignoreWindow) {
            this.windowRef.close();
        }
    };
    LayerSpatialQueryComponent.prototype.sortStringObj = function (sortBy, obj) {
        obj.sort(function (a, b) {
            if (a[sortBy].localeCompare(b[sortBy]) > 0) {
                return 1;
            }
            else if (a[sortBy].localeCompare(b[sortBy]) < 0) {
                return -1;
            }
            return 0;
        });
    };
    LayerSpatialQueryComponent.prototype.getLayerIdByName = function (name) {
        return environment.layers.filter(function (x) { return x.name === name; })[0].id;
    };
    return LayerSpatialQueryComponent;
}(BaseComponent));
export { LayerSpatialQueryComponent };
